import React, { useEffect, useState } from 'react';

import styled from 'styled-components';

import { addCustomerLog } from '@libs/NwLogs';

import { useStateValue } from '@contexts/StateProvider';
import { useUserPermission } from '@contexts/UserContext';

import { useContact } from '@hooks/API/Contact/UseContact';
import { useContactBillingInfos } from '@hooks/API/Contact/UseContactBillingInfos';
import useNwBreakPoints from '@hooks/Layout/UseNwBreakPoints';

import ContactDetailsActions from '@components/ContactDetails/ContactDetailsHeader/ContactDetailsActions';
import ObjectHistory from '@components/CreatedBy/ObjectHistory';
import FlexContainer from '@components/Gui/FlexContainer';
import { Loading } from '@components/Gui/Loading';
import NwDrawer from '@components/Gui/NwDrawer';
import NwIcon from '@components/Gui/NwIcon';
import SystemMessage from '@components/Utils/SystemMessage';

import CustomerDetailsAccountingContent from '../CustomerDetailsAccountingContent';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const Actions = styled(FlexContainer)`
    gap: 2rem;
    margin-right: 1rem;
`;

const CustomerDrawerAccounting = ({ customerID, onClose, onReloadSearch }) => {
    const loading = false;
    const { data: currentCustomer } = useContact(customerID);
    const { data: billingInfos } = useContactBillingInfos(customerID);

    const [{ areaContext }] = useStateValue();

    const accessAccounting = useUserPermission('AccessAccounting');

    const [isOpenHistory, setIsOpenHistory] = useState(false);

    const breakpoints = useNwBreakPoints();
    const isMobile = breakpoints === 1;

    useEffect(() => {
        if (currentCustomer) {
            addCustomerLog(currentCustomer, areaContext.area);
        }
    }, [currentCustomer]);

    if (!accessAccounting) {
        return (
            <NwDrawer width={400} onClose={onClose} whiteBg padding="0">
                <SystemMessage type="not-allowed" />
            </NwDrawer>
        );
    }

    return (
        <NwDrawer
            width="90vw"
            title={
                currentCustomer ? (
                    <FlexContainer justifyContent="space-between">
                        <div>Customer (Accounting Details)</div>
                        <Actions>
                            {/* <NwIcon
                                icon={byPrefixAndName.fasl['history']}
                                size="lg"
                                pointer
                                onClick={() => {}} //handleOpenHistory
                            /> */}
                            <ObjectHistory iconOnly onIconClick={() => {}} object={currentCustomer} />
                            <ContactDetailsActions
                                contact={currentCustomer}
                                fromDrawer
                                onClose={onClose}
                                onReloadSearch={onReloadSearch}
                            />
                        </Actions>
                    </FlexContainer>
                ) : (
                    'Customer Preview'
                )
            }
            onClose={onClose}
            whiteBg={false}
        >
            <div className="drawer-content">
                {loading || !currentCustomer ? (
                    <Loading />
                ) : (
                    <CustomerDetailsAccountingContent
                        currentCustomer={currentCustomer}
                        billingInfos={billingInfos}
                        onReloadSearch={onReloadSearch}
                    />
                )}
            </div>
        </NwDrawer>
    );
};

export default CustomerDrawerAccounting;
